import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import ProductProcessHistory from './product-process-history';
import ProductProcessHistoryDetail from './product-process-history-detail';
import ProductProcessHistoryUpdate from './product-process-history-update';
import ProductProcessHistoryDeleteDialog from './product-process-history-delete-dialog';

const ProductProcessHistoryRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<ProductProcessHistory />} />
    <Route path="new" element={<ProductProcessHistoryUpdate />} />
    <Route path=":id">
      <Route index element={<ProductProcessHistoryDetail />} />
      <Route path="edit" element={<ProductProcessHistoryUpdate />} />
      <Route path="delete" element={<ProductProcessHistoryDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default ProductProcessHistoryRoutes;
